export default __webpack_public_path__ + "static/media/kukkesubramaynaswamitemp.06c3b823.jpg";